













import Vue from 'vue'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'

interface ComponentData {
  selectedItem: AdditionalFieldItem | undefined
}

export default Vue.extend({
  name: 'AdditionalFieldsSelect',

  props: {
    items: {
      type: Array as () => Array<AdditionalFieldItem>
    },
    defaultValue: String
  },

  data (): ComponentData {
    return {
      selectedItem: undefined,
    }
  },

  methods: {
    onSelectChange (item: AdditionalFieldItem): void {
      this.$emit('onValueChange', item)
    }
  },

  created () {
    if(this.defaultValue) {
      const foundItem: AdditionalFieldItem | undefined = this.items.find((item: AdditionalFieldItem) => item.value === this.defaultValue)
      if(foundItem) {
        this.selectedItem = foundItem
      }
    }
  }

})
